import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CashbackEffects } from './store/effects/cashback.effects';
import { cashbackReducer } from './store/reducers/cashback.reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([CashbackEffects]),
    StoreModule.forFeature('cashback', cashbackReducer),
  ],
})
export class CashbackModule {}
